const replaceHTMLAttributes = (
  htmlString,
  attributeName,
  replacementString,
) => {
  // Create a regular expression pattern to match the attribute value
  const regex = new RegExp(`${attributeName}=["'](.*?)["']`, "g");

  // Use the `replace` method to replace the attribute values
  const modifiedHTML = htmlString.replace(
    regex,
    `${attributeName}="${replacementString}"`,
  );

  return modifiedHTML;
};

var removeHTMLAttributes = (htmlString, attributeName) => {
  // Create a regular expression pattern to match the attribute value
  const regex = new RegExp(`${attributeName}=["'](.*?)["']`, "g");

  // Use the `replace` method to replace the attribute values
  const modifiedHTML = htmlString.replace(regex, "");

  return modifiedHTML;
};

var triggerEvent = (element, name, data = {}) => {
  window.events = window.events || {};
  if (!window.events[name]) {
    window.events[name] = debounce((element, name, data) => {
      element.dispatchEvent(
        new CustomEvent(name, {
          bubbles: true,
          detail: data,
        }),
      );
    }, 300);
  }
  window.events[name](element, name, data);
};

var delegate = (parent, eventName, childSelector, callback) => {
  if (typeof childSelector === "function") {
    callback = childSelector;
    childSelector = null;
  }
  const selector = childSelector
    ? childSelector
    : "." + [...parent.classList].join(".").replaceAll(":", "\\:");
  parent.addEventListener(eventName, (event) => {
    const target = event.target.closest(selector);
    if (target) {
      callback(event, target);
    }
  });
};

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

var trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function (e) {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*",
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document
    .querySelectorAll("model-viewer")
    .forEach((model) => model.modelViewerUI?.pause());
}

function pauseThisMedia(media) {
  if (media.tagName === "VIDEO") {
    media.pause();
  } else if (media.tagName === "IFRAME") {
    if (media.classList.contains("js-youtube")) {
      media.contentWindow.postMessage(
        JSON.stringify({ event: "command", func: "stopVideo", args: [] }),
        "*",
      );
    } else if (media.classList.contains("js-vimeo")) {
      media.contentWindow.postMessage('{"method":"pause"}', "*");
    }
  } else if (media.tagName === "MODEL-VIEWER") {
    media.modelViewerUI?.pause();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

// Scroll lock manager with reference counting
var scrollLockManager = {
  lockedBy: new Set(),
  scrollY: 0,
  /** @type {'fixed' | 'overflow' | null} */
  lockMode: null,

  /**
   * Read current page scroll from all common scrolling roots.
   * @returns {number}
   */
  getCurrentScrollY() {
    return window.scrollY
      || window.pageYOffset
      || document.documentElement.scrollTop
      || document.body.scrollTop
      || 0;
  },

  /**
   * Restore scroll position for both body-scrolling and window-scrolling pages.
   * @param {number} top
   */
  restoreScrollY(top) {
    const html = document.documentElement;
    const body = document.body;
    const prevHtmlBehavior = html.style.scrollBehavior;
    const prevBodyBehavior = body.style.scrollBehavior;

    // Override theme-level `scroll-smooth` so lock/unlock never animates.
    html.style.scrollBehavior = "auto";
    body.style.scrollBehavior = "auto";

    document.documentElement.scrollTop = top;
    document.body.scrollTop = top;
    window.scrollTo(0, top);

    requestAnimationFrame(() => {
      html.style.scrollBehavior = prevHtmlBehavior;
      body.style.scrollBehavior = prevBodyBehavior;
    });
  },

  /**
   * @param {Element} element
   * @param {{ mode?: 'fixed' | 'overflow' }} [options]
   */
  lock(element, options = {}) {
    if (this.lockedBy.size === 0) {
      this.scrollY = this.getCurrentScrollY();
      this.lockMode = options.mode === "overflow" ? "overflow" : "fixed";

      if (this.lockMode === "overflow") {
        document.documentElement.style.overflow = "hidden";
        document.body.style.overflow = "hidden";
        this.restoreScrollY(this.scrollY);
      } else {
        document.body.style.position = "fixed";
        document.body.style.top = `-${this.scrollY}px`;
        document.body.style.width = "100%";
      }
    }

    this.lockedBy.add(element);
    element.dataset.scrollY = String(this.scrollY);
  },

  unlock(element) {
    this.lockedBy.delete(element);

    if (this.lockedBy.size === 0) {
      if (this.lockMode === "overflow") {
        document.documentElement.style.overflow = "";
        document.body.style.overflow = "";
        const currentScroll = this.getCurrentScrollY();
        if (Math.abs(currentScroll - this.scrollY) > 1) {
          this.restoreScrollY(this.scrollY);
        }
      } else {
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.width = "";
        this.restoreScrollY(this.scrollY);
      }
      this.lockMode = null;
    }
  },

  isLocked() {
    return this.lockedBy.size > 0;
  },

  clear() {
    this.lockedBy.clear();
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = "";
    this.lockMode = null;
  }
};

// Maintain backward compatibility
/**
 * @param {Element} element
 * @param {{ mode?: 'fixed' | 'overflow' }} [options]
 */
function lockScrollForThis(element, options = {}) {
  scrollLockManager.lock(element, options);
}

function unlockScrollForThis(element) {
  scrollLockManager.unlock(element);
}

function preventDefault(e) {
  e.preventDefault();
}

function handleImageError(imgElement) {
  imgElement.classList.add("hidden");
  const fallback = imgElement.parentElement.querySelector(".fallback");
  fallback.classList.remove("hidden");
}

function getPathWithoutQuery(url) {
  return new URL(url, window.location.origin).pathname;
}
function replaceNodeWithNodeList(nodeToReplace, nodeList) {
  if (!(nodeList instanceof NodeList) && !Array.isArray(nodeList)) {
    throw new Error("Second argument must be a NodeList or an array of nodes");
  }

  const parent = nodeToReplace.parentNode;
  if (!parent) {
    throw new Error("Cannot replace a node that is not in the DOM");
  }

  const fragment = document.createDocumentFragment();

  // If it's an array, we need to iterate differently
  if (Array.isArray(nodeList)) {
    nodeList.forEach((node) => fragment.appendChild(node));
  } else {
    // NodeList is array-like but not an array, so we use this method
    fragment.append(...nodeList);
  }

  parent.replaceChild(fragment, nodeToReplace);
}

function toggleButtonState(button, state) {
  switch (state) {
    case "loading":
      if (button.dataset.state == "loading") return;
      button.setAttribute("aria-disabled", true);
      button.dataset.state = "loading";
      break;

    case "error":
      button.dataset.state = "error";
      button.removeAttribute("aria-disabled");
      navigator.vibrate(100);
      setTimeout(() => button.removeAttribute("data-state"), 3000);
      break;

    case "success":
      button.dataset.state = "success";
      button.removeAttribute("aria-disabled");
      navigator.vibrate(100);
      setTimeout(() => button.removeAttribute("data-state"), 3000);
      break;
  }
}

function updateLabels() {
  const labels = document.querySelectorAll("drawer accordion-content label");
  labels.forEach((label) => {
    const attr = label.getAttribute("for");
    const input = label.querySelector("input");
    if (input) input.setAttribute("id", attr);
    label.setAttribute("for", attr);
    label.control = input;
  });
}

function getVisibleHeight(element) {
  // Get the element's bounding rectangle
  const rect = element.getBoundingClientRect();

  // Get viewport height
  const viewportHeight =
    window.innerHeight || document.documentElement.clientHeight;

  // Calculate top and bottom edges relative to viewport
  const elementTop = rect.top;
  const elementBottom = rect.bottom;

  // Element is completely above or below viewport
  if (elementTop >= viewportHeight || elementBottom <= 0) {
    return 0;
  }

  // Element is partially visible
  if (elementTop < 0) {
    // Element is clipped at top
    return Math.min(elementBottom, viewportHeight);
  }

  if (elementBottom > viewportHeight) {
    // Element is clipped at bottom
    return viewportHeight - elementTop;
  }

  // Element is fully visible
  return rect.height;
}

// fix childMenu positions
var fixChildMenuPositions = () => {
  const childMenus = document.querySelectorAll("._headerChildMenu");
  const isRTL = document.body.style.direction === "rtl";
  const windowWidth = window.innerWidth;

  childMenus.forEach((childMenu) => {
    let isOffScreen = false;
    const childMenuRect = childMenu.getBoundingClientRect();

    // Check if the child menu itself is off-screen
    if (isRTL) {
      isOffScreen = childMenuRect.left < 0;
    } else {
      isOffScreen = childMenuRect.right > windowWidth;
    }

    // If child menu is not off-screen, check its grandchild menus
    if (!isOffScreen) {
      const grandChildMenus = childMenu.querySelectorAll(
        "._headerGrandChildMenu",
      );
      grandChildMenus.forEach((grandChildMenu) => {
        // Temporarily make the grandchild menu visible for accurate measurements
        const originalDisplay = grandChildMenu.style.display;
        grandChildMenu.style.display = "block";
        grandChildMenu.style.visibility = "hidden";

        const grandChildMenuRect = grandChildMenu.getBoundingClientRect();

        // Restore original display
        grandChildMenu.style.display = originalDisplay;
        grandChildMenu.style.visibility = "";

        if (isRTL) {
          if (grandChildMenuRect.left < 0) isOffScreen = true;
        } else {
          if (grandChildMenuRect.right > windowWidth) isOffScreen = true;
        }
      });
    }

    if (isOffScreen) {
      childMenu.setAttribute("data-offscreen", "true");
    } else {
      childMenu.removeAttribute("data-offscreen");
    }
  });
};

/** @type {AbortController | null} */
let menuPositionAbort = null;

/**
 * Bind resize / DOMContentLoaded listeners for submenu overflow correction.
 * Idempotent; pagehide aborts so bfcache pageshow can re-bind.
 */
function initMenuPositionListeners() {
  if (menuPositionAbort) return;
  if (typeof window === "undefined" || typeof document === "undefined") return;

  menuPositionAbort = new AbortController();
  const { signal } = menuPositionAbort;
  window.addEventListener("resize", fixChildMenuPositions, { passive: true, signal });
  if (document.readyState === "loading") {
    window.addEventListener("DOMContentLoaded", fixChildMenuPositions, { signal });
  } else {
    fixChildMenuPositions();
  }
  window.addEventListener(
    "pagehide",
    () => {
      menuPositionAbort?.abort();
      menuPositionAbort = null;
    },
    { once: true, signal },
  );
}

initMenuPositionListeners();

// bfcache restore: pagehide tears listeners down; re-bind on pageshow
window.addEventListener("pageshow", (event) => {
  if (event.persisted) {
    initMenuPositionListeners();
  }
});


function initImageTextSliders() {
  document.querySelectorAll('.js-image-text-toggle').forEach((el) => {
    el.addEventListener('click', () => {
      el.classList.toggle('active');
    });
  });
}

['DOMContentLoaded', 'shopify:section:load'].forEach((event) => {
  document.addEventListener(event, initImageTextSliders);
});

var normalize = (str) => str?.toString().trim().toLowerCase() || '';

/**
 * Run callback when main thread is idle to reduce Total Blocking Time (Lighthouse).
 * Uses requestIdleCallback when available, with setTimeout fallback and timeout cap.
 * @param {() => void} callback - Work to run during idle time
 * @param {{ timeout?: number }} [options] - Optional timeout in ms (default 2000)
 */
function scheduleIdle(callback, options = {}) {
  const timeout = options.timeout ?? 2000;
  if (typeof requestIdleCallback !== 'undefined') {
    const id = requestIdleCallback(callback, { timeout });
    return () => cancelIdleCallback(id);
  }
  const id = setTimeout(callback, 1);
  return () => clearTimeout(id);
}

function isCartMutationLocked() {
  return window.__electricCartMutationInFlight === true;
}

function setCartMutationLock(isLocked) {
  const locked = Boolean(isLocked);
  window.__electricCartMutationInFlight = locked;
  document.documentElement.toggleAttribute('data-cart-mutating', locked);

  const cartInteractionRoots = [
    ...document.querySelectorAll('cart-dynamic'),
    ...document.querySelectorAll('drawer-element#cart-drawer drawer'),
  ];

  cartInteractionRoots.forEach((element) => {
    if (!element) return;
    element.toggleAttribute('data-cart-mutating', locked);
    element.setAttribute('aria-busy', locked ? 'true' : 'false');
  });
}

function scheduleCartCountVerification(expectedItemCount, onMismatch, delay = 1000) {
  if (window.__electricCartCountVerificationTimeout) {
    window.clearTimeout(window.__electricCartCountVerificationTimeout);
  }

  window.__electricCartCountVerificationTimeout = window.setTimeout(async () => {
    try {
      const cartUrl = window.routes?.cart_url || '/cart';
      const response = await fetch(/\.js(\?|$)/.test(cartUrl) ? cartUrl : `${cartUrl}.js`);
      if (!response.ok) return;

      const cart = await response.json();
      if (typeof expectedItemCount === 'number' && cart.item_count !== expectedItemCount) {
        onMismatch?.(cart);
      }
    } catch (_error) {
      // Silent verification fallback
    } finally {
      window.__electricCartCountVerificationTimeout = null;
    }
  }, delay);
}



const PRESERVED_DYNAMIC_ATTRIBUTES = new Set([
  'data-variant-dynamic',
  'data-keep',
  'data-remove',
  'data-product-id',
]);

const VARIANT_DYNAMIC_LOADING_CLASSES = new Set([
  'opacity-20',
  'transition-opacity',
  'duration-200',
]);

/**
 * Remove variant-fetch loading classes from an element.
 * @param {Element} element
 */
function stripVariantDynamicLoadingClasses(element) {
  for (const className of VARIANT_DYNAMIC_LOADING_CLASSES) {
    element.classList.remove(className);
  }
}

/**
 * Re-bind product root context on replaced custom elements (variant-radios, product-form).
 * Constructor may run before the node is in the product tree, leaving dataset.product empty.
 * @param {Element} element
 * @param {Element|null} productRoot
 */
function syncCustomElementProductContext(element, productRoot) {
  const root =
    element.productParentElement ||
    element.closest('[data-section][data-product]') ||
    productRoot;

  if (!root) return;

  element.productParentElement = root;

  if (!element.dataset.section) {
    element.dataset.section = root.dataset.section;
  }

  if (!element.dataset.product) {
    element.dataset.product = root.dataset.product;
  }
}

/**
 * Resolve a Shopify section instance ID for Section Rendering API requests.
 * @param {Element} element
 * @returns {string|null}
 */
function resolveSectionId(element) {
  if (element.dataset.sectionId) {
    return element.dataset.sectionId;
  }

  const dataSectionElement = element.closest('[data-section]');
  if (dataSectionElement?.dataset.section) {
    return dataSectionElement.dataset.section;
  }

  const shopifySection = element.closest('[id^="shopify-section-"]');
  if (shopifySection?.id) {
    return shopifySection.id.startsWith('shopify-section-')
      ? shopifySection.id.slice('shopify-section-'.length)
      : shopifySection.id;
  }

  return null;
}

/**
 * Whether a variant-dynamic element belongs to the active product context.
 * @param {Element} element
 * @param {Element|null} productRoot
 * @param {string|undefined} productId
 * @returns {boolean}
 */
function belongsToProduct(element, productRoot, productId) {
  if (productRoot?.contains(element)) {
    return true;
  }

  if (!productId) {
    return false;
  }

  const productIdString = String(productId);
  const foreignProductRoot = element.closest('[data-section][data-product]');

  if (
    foreignProductRoot &&
    foreignProductRoot.dataset.product !== productIdString
  ) {
    return false;
  }

  // PDP sections below the fold (transparent pricing, icons model, etc.) sit in
  // sibling shopify-section wrappers — not inside [data-section][data-product].
  if (productRoot && window.location.pathname.includes('/products/')) {
    const mainSection = productRoot.closest('[id^="shopify-section-"]');
    const elementSection = element.closest('[id^="shopify-section-"]');

    if (
      mainSection &&
      elementSection &&
      elementSection !== mainSection
    ) {
      return true;
    }
  }

  let current = element;

  while (current && current !== document.body) {
    if (current.dataset?.productId === productIdString) {
      return true;
    }
    current = current.parentElement;
  }

  const shopifySection = element.closest('[id^="shopify-section-"]');
  if (shopifySection?.querySelector(`[data-product-id="${productIdString}"]`)) {
    return true;
  }

  return false;
}

/**
 * Drop nested variant-dynamic nodes when an ancestor is also in the set.
 * Parent innerHTML replacement already updates descendants.
 * @param {Element[]} elements
 * @returns {Element[]}
 */
function filterNestedVariantDynamicElements(elements) {
  return elements.filter(
    (element) =>
      !elements.some(
        (other) => other !== element && other.contains(element),
      ),
  );
}

/**
 * Collect variant-dynamic elements for the current product update scope.
 * @param {Object} options
 * @param {Element|Document} [options.scope=document]
 * @param {Element|null} [options.productRoot]
 * @param {string|undefined} [options.productId]
 * @param {boolean} [options.pageWide=false]
 * @returns {Element[]}
 */
function collectVariantDynamicElements({
  scope = document,
  productRoot = null,
  productId,
  pageWide = false,
}) {
  const elements = [...scope.querySelectorAll('[data-variant-dynamic]')];

  let filtered;
  if (!pageWide) {
    filtered = productRoot
      ? elements.filter((element) => productRoot.contains(element))
      : elements;
  } else {
    filtered = elements.filter((element) =>
      belongsToProduct(element, productRoot, productId),
    );
  }

  return filterNestedVariantDynamicElements(filtered);
}

/**
 * Group variant-dynamic elements by their owning section ID.
 * @param {Element[]} elements
 * @returns {Map<string, Element[]>}
 */
function groupElementsBySection(elements) {
  /** @type {Map<string, Element[]>} */
  const sections = new Map();

  for (const element of elements) {
    const sectionId = resolveSectionId(element);
    if (!sectionId) {
      continue;
    }

    const sectionElements = sections.get(sectionId) ?? [];
    sectionElements.push(element);
    sections.set(sectionId, sectionElements);
  }

  return sections;
}

/**
 * Sort section IDs so the primary PDP section updates first.
 * @param {string[]} sectionIds
 * @param {string|null|undefined} primarySectionId
 * @returns {string[]}
 */
function sortSectionIds(sectionIds, primarySectionId) {
  if (!primarySectionId) {
    return sectionIds;
  }

  return [...sectionIds].sort((left, right) => {
    if (left === primarySectionId) return -1;
    if (right === primarySectionId) return 1;
    return 0;
  });
}

/**
 * Apply data-keep / data-remove transformations to fetched section HTML.
 * @param {string} htmlString
 * @param {Element[]} elements
 * @returns {string}
 */
function applyKeepRemoveToHtml(htmlString, elements) {
  let updatedHtml = htmlString;

  for (const element of elements) {
    if (element.dataset.keep) {
      try {
        const kept = JSON.parse(element.dataset.keep);
        for (const [attributeName, attributeValue] of Object.entries(kept)) {
          updatedHtml = replaceHTMLAttributes(
            updatedHtml,
            attributeName,
            attributeValue,
          );
        }
      } catch (_) {}
    }

    if (element.dataset.remove) {
      for (const attributeName of element.dataset.remove.split(',')) {
        updatedHtml = removeHTMLAttributes(updatedHtml, attributeName.trim());
      }
    }
  }

  return updatedHtml;
}

/**
 * Sync non-reserved attributes after innerHTML replacement.
 * @param {Element} destination
 * @param {Element} source
 */
function syncVariantDynamicElementAttributes(destination, source) {
  for (const attribute of source.attributes) {
    if (PRESERVED_DYNAMIC_ATTRIBUTES.has(attribute.name)) continue;
    destination.setAttribute(attribute.name, attribute.value);
  }

  for (const attribute of destination.attributes) {
    if (PRESERVED_DYNAMIC_ATTRIBUTES.has(attribute.name)) continue;
    if (!source.hasAttribute(attribute.name)) {
      destination.removeAttribute(attribute.name);
    }
  }
}

/**
 * Replace a single variant-dynamic destination from fetched source markup.
 * @param {Element} destination
 * @param {Element} source
 * @param {Object} [options]
 * @param {Element|null} [options.productRoot]
 * @param {string[]} [options.preservedSelectedOptions]
 * @returns {boolean}
 */
function replaceVariantDynamicElement(
  destination,
  source,
  { productRoot = null, preservedSelectedOptions = [] } = {},
) {
  if (destination.tagName === 'VARIANT-RADIOS' || destination.tagName === 'PRODUCT-FORM') {
    const correctProductParent =
      destination.productParentElement ||
      destination.closest('[data-section][data-product]') ||
      productRoot;

    const tagName = destination.tagName.toLowerCase();
    let attrs = '';

    for (const attribute of destination.attributes) {
      if (attribute.name === 'data-variant-dynamic') continue;

      if (attribute.name === 'class') {
        const classes = attribute.value
          .split(/\s+/)
          .filter(
            (className) =>
              className && !VARIANT_DYNAMIC_LOADING_CLASSES.has(className),
          );

        if (classes.length) {
          attrs += ` class="${classes.join(' ')}"`;
        }
        continue;
      }

      attrs += ` ${attribute.name}="${attribute.value.replace(/"/g, '&quot;')}"`;
    }

    if (source.dataset.variantDynamic) {
      attrs += ` data-variant-dynamic="${source.dataset.variantDynamic}"`;
    }

    const tempContainer = document.createElement('div');
    tempContainer.innerHTML = `<${tagName}${attrs}>${source.innerHTML}</${tagName}>`;
    const newElement = tempContainer.firstElementChild;
    if (!newElement) return false;

    destination.replaceWith(newElement);
    stripVariantDynamicLoadingClasses(newElement);
    syncCustomElementProductContext(newElement, correctProductParent || productRoot);

    if (correctProductParent && newElement.productParentElement !== correctProductParent) {
      newElement.productParentElement = correctProductParent;
      syncCustomElementProductContext(newElement, correctProductParent);
    }

    if (
      destination.tagName === 'VARIANT-RADIOS' &&
      preservedSelectedOptions.length > 0 &&
      newElement.tagName === 'VARIANT-RADIOS'
    ) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          newElement.querySelectorAll('fieldset').forEach((fieldset, index) => {
            const targetValue = preservedSelectedOptions[index];
            if (!targetValue) return;

            const currentlyChecked = fieldset.querySelector('input[type="radio"]:checked');
            if (currentlyChecked?.value === targetValue) return;

            const radioToSelect = [...fieldset.querySelectorAll('input[type="radio"]')].find(
              (radio) => radio.value === targetValue && !radio.disabled,
            );

            if (!radioToSelect) return;

            if (currentlyChecked) {
              currentlyChecked.checked = false;
            }
            radioToSelect.checked = true;
          });
        });
      });
    }

    return true;
  }

  destination.innerHTML = source.innerHTML;
  syncVariantDynamicElementAttributes(destination, source);
  return true;
}

const CUSTOM_ELEMENT_DYNAMIC_IDS = new Set(['variant-radios']);

function sortDynamicIdsForUpdate(dynamicIds) {
  return [...dynamicIds].sort((left, right) => {
    const leftIsLast = CUSTOM_ELEMENT_DYNAMIC_IDS.has(left) ? 1 : 0;
    const rightIsLast = CUSTOM_ELEMENT_DYNAMIC_IDS.has(right) ? 1 : 0;
    return leftIsLast - rightIsLast;
  });
}

/**
 * Update variant-dynamic elements from fetched section HTML.
 * @param {Object} options
 * @param {string} options.htmlString
 * @param {Element[]} options.elements
 * @param {Element|null} [options.productRoot]
 * @param {string[]} [options.preservedSelectedOptions]
 * @returns {number}
 */
function updateElementsFromSectionHtml({
  htmlString,
  elements,
  productRoot = null,
  preservedSelectedOptions = [],
}) {
  const processedHtml = applyKeepRemoveToHtml(htmlString, elements);
  const parsedDocument = new DOMParser().parseFromString(processedHtml, 'text/html');
  const dynamicIds = new Set(
    elements.map((element) => element.dataset.variantDynamic ?? ''),
  );

  let updatedCount = 0;

  for (const dynamicId of sortDynamicIdsForUpdate(dynamicIds)) {
    const source = parsedDocument.querySelector(
      `[data-variant-dynamic="${dynamicId}"]`,
    );
    if (!source) {
      continue;
    }

    const destinations = elements.filter(
      (element) => (element.dataset.variantDynamic ?? '') === dynamicId,
    );

    for (const destination of destinations) {
      if (
        replaceVariantDynamicElement(destination, source, {
          productRoot,
          preservedSelectedOptions,
        })
      ) {
        updatedCount += 1;
      }
    }
  }

  return updatedCount;
}

/**
 * Toggle loading state on variant-dynamic elements.
 * @param {Element[]} elements
 * @param {boolean} isLoading
 */
function setVariantDynamicLoadingState(elements, isLoading) {
  for (const element of elements) {
    if (isLoading) {
      element.classList.add('opacity-20');
    } else {
      element.classList.remove('opacity-20');
    }
  }
}

/**
 * Fetch and apply variant-dynamic updates per section without waiting for all sections.
 * Primary section updates first; downstream sections apply independently as they resolve.
 * @param {Object} options
 * @param {(sectionId: string) => string} options.buildFetchUrl
 * @param {Element[]} options.elements
 * @param {Element|null} [options.productRoot]
 * @param {string|null|undefined} [options.primarySectionId]
 * @param {string[]} [options.preservedSelectedOptions]
 * @param {AbortSignal} [options.signal]
 * @param {(detail: { sectionId: string, phase: 'beforeReplace' | 'afterReplace', variantId?: string|number }) => void} [options.dispatchEvent]
 * @param {string|number} [options.variantId]
 * @returns {Promise<{ updatedSections: number, updatedElements: number }>}
 */
async function updateVariantDynamicSections({
  buildFetchUrl,
  elements,
  productRoot = null,
  primarySectionId,
  preservedSelectedOptions = [],
  signal,
  dispatchEvent,
  variantId,
}) {
  const sectionMap = groupElementsBySection(elements);
  const sectionIds = sortSectionIds([...sectionMap.keys()], primarySectionId);

  if (sectionIds.length === 0) {
    return { updatedSections: 0, updatedElements: 0 };
  }

  setVariantDynamicLoadingState(elements, true);

  let updatedSections = 0;
  let updatedElements = 0;
  let pendingSections = sectionIds.length;

  const finishSection = (sectionElements) => {
    setVariantDynamicLoadingState(sectionElements, false);
    pendingSections -= 1;

    if (pendingSections <= 0) {
      setVariantDynamicLoadingState(elements, false);
    }
  };

  const applySectionHtml = (sectionId, sectionElements, htmlString) => {
    const isPrimarySection = sectionId === primarySectionId;

    if (isPrimarySection) {
      dispatchEvent?.({
        sectionId,
        phase: 'beforeReplace',
        variantId,
      });
    }

    updatedElements += updateElementsFromSectionHtml({
      htmlString,
      elements: sectionElements,
      productRoot,
      preservedSelectedOptions: isPrimarySection ? preservedSelectedOptions : [],
    });
    updatedSections += 1;

    if (isPrimarySection) {
      dispatchEvent?.({
        sectionId,
        phase: 'afterReplace',
        variantId,
      });
    }

    finishSection(sectionElements);
  };

  const fetchSection = async (sectionId) => {
    const sectionElements = sectionMap.get(sectionId) ?? [];
    if (sectionElements.length === 0) {
      pendingSections -= 1;
      return;
    }

    try {
      const response = await fetch(buildFetchUrl(sectionId), {
        signal,
        headers: {
          Accept: 'text/html',
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch section ${sectionId}: HTTP ${response.status}`);
      }

      applySectionHtml(sectionId, sectionElements, await response.text());
    } catch (error) {
      finishSection(sectionElements);

      if (error.name !== 'AbortError') {
        console.error('VariantDynamicUpdater: section fetch failed', error);
      }

      throw error;
    }
  };

  const [primarySectionIdValue, ...remainingSectionIds] = sectionIds;

  try {
    await fetchSection(primarySectionIdValue);
  } catch (error) {
    if (error.name === 'AbortError') {
      setVariantDynamicLoadingState(elements, false);
      throw error;
    }
  }

  for (const sectionId of remainingSectionIds) {
    fetchSection(sectionId).catch((error) => {
      if (error.name === 'AbortError') {
        setVariantDynamicLoadingState(elements, false);
      }
    });
  }

  return { updatedSections, updatedElements };
}




if (!customElements.get("variant-radios")) {
  class VariantRadios extends HTMLElement {
    /** Matches `@theme --breakpoint-lg` in _styles/main.css (desktop-only instock filter). */
    static #INSTOCK_ONLY_MIN_WIDTH_MQ = "(min-width: 60rem)";

    /** @type {MediaQueryList | null} */
    #instockOnlyDesktopMql = null;
    /** @type {(() => void) | null} */
    #instockOnlyMqlListener = null;
    /** @type {AbortController | null} */
    #variantDynamicAbortController = null;
    /** @type {number} */
    #variantDynamicRequestId = 0;

    constructor() {
      super();
      this.quickAtcMode = this.dataset.quickAtcMode === 'true';
      this.productParentElement = this.closest(`[data-section][data-product]`);
      this.#rebindProductContext();
      this.fieldsets = [...this.querySelectorAll("fieldset")];
      this.#collectVariantRadios();
      this.qtyInput = this.productParentElement?.querySelector("quantity-input");
      this.productButtons =
        this.productParentElement?.querySelectorAll("product-buttons");
      this.productForms =
        this.productParentElement?.querySelectorAll("product-form");
      this.stickyAtcs =
        this.productParentElement?.querySelectorAll("sticky-atc");
      this.outputs =
        this.productParentElement?.querySelectorAll("._selectedOption");
      this.stickyOutput = document.querySelector('._stickyOutput');
      this.stickyImageOutput = document.querySelector('._stickyImageOutput');
      // Don't add listener in constructor - let connectedCallback handle it
      // this.addEventListener("change", this.onVariantChange);
      this.dataset.family && this.fetchFamilyColors();
      this.quantitySelector =
        this.productParentElement?.querySelector("quantity-input");

      // Initialize combined listings data (option-based product mappings)
      this.optionVariants = null;
      this.optionUrls = null;
      this.hasCombinedListings = false;
      this.currentProductUrl = null;

      if (
        window.location.href.includes("?") ||
        window.location.href.includes("&")
      ) {
        this.urlSearchParams = window.location.href
          .replace(this.dataset.url, "")
          .replace(window.location.origin, "");
      } else {
        this.urlSearchParams = "";
      }

      this.handleFirstClick();
    }

    connectedCallback() {
      this.#rebindProductContext();

      // Set up change event listener
      // Store the bound handler so we can remove it later if needed
      if (!this._changeHandler) {
        this._changeHandler = this.onVariantChange.bind(this);
      }
      this.addEventListener("change", this._changeHandler);
      
      // Set up instock-only checkbox change listener
      const instockCheckbox = this.querySelector('#instock-only');
      if (instockCheckbox && !instockCheckbox._hasListener) {
        instockCheckbox._hasListener = true;
        instockCheckbox.addEventListener('change', () => {
          this.updateInstockOnlyFilter();
        });
      }
      
      // Refresh fieldsets and variant radios in case DOM changed
      this.fieldsets = [...this.querySelectorAll("fieldset")];
      this.#collectVariantRadios();
      this.#loadOptionData();
      // Update all fieldsets based on current selections (checks all fieldsets internally)
      this.updateVariantsBasedOn();
      this.#setupInstockOnlyViewportListener();
    }

    disconnectedCallback() {
      if (this.#instockOnlyDesktopMql && this.#instockOnlyMqlListener) {
        this.#instockOnlyDesktopMql.removeEventListener(
          "change",
          this.#instockOnlyMqlListener
        );
      }
      this.#instockOnlyDesktopMql = null;
      this.#instockOnlyMqlListener = null;
    }

    /**
     * "In stock only" applies at lg+ only; clear filter state when viewport is smaller.
     * @private
     */
    #setupInstockOnlyViewportListener() {
      if (this.#instockOnlyMqlListener !== null) return;
      if (typeof window.matchMedia !== "function") return;
      this.#instockOnlyDesktopMql = window.matchMedia(
        VariantRadios.#INSTOCK_ONLY_MIN_WIDTH_MQ
      );
      this.#instockOnlyMqlListener = () => this.updateInstockOnlyFilter();
      this.#instockOnlyDesktopMql.addEventListener(
        "change",
        this.#instockOnlyMqlListener
      );
    }

    /**
     * @returns {boolean}
     * @private
     */
    #isInstockOnlyDesktopViewport() {
      if (typeof window.matchMedia !== "function") return false;
      return window.matchMedia(VariantRadios.#INSTOCK_ONLY_MIN_WIDTH_MQ).matches;
    }

    handleFirstClick() {}

    /**
     * Keep dataset.section / dataset.product in sync with the product root.
     * Required after variant-dynamic replace when constructor ran off-document.
     * @private
     */
    #rebindProductContext() {
      if (!this.productParentElement) {
        this.productParentElement = this.closest('[data-section][data-product]');
      }

      if (!this.productParentElement) return;

      this.dataset.section =
        this.dataset.section || this.productParentElement.dataset.section;
      this.dataset.product = this.productParentElement.dataset.product;
    }

    /**
     * Collect all variant radio inputs from fieldsets for validation
     * @private
     */
    #collectVariantRadios() {
      this.variantRadios = new Set();
      this.fieldsets.forEach(fieldset => {
        [...fieldset.elements]
          .filter(el => el.type === 'radio')
          .forEach(radio => this.variantRadios.add(radio));
      });
    }

    /**
     * Check if change event is from an actual variant radio input
     * @param {Event} e - Change event
     * @returns {boolean} True if event is from a variant radio, false otherwise
     * @private
     */
    #isVariantRadioChange(e) {
      return this.variantRadios.has(e.target);
    }

    /**
     * Load option-based variant data and URLs for combined listings
     * @private
     */
    #loadOptionData() {
      try {
        const optionVariantsElement = this.querySelector('.variant-option-variants-json');
        const optionUrlsElement = this.querySelector('.variant-option-urls-json');
        
        if (optionVariantsElement) {
          this.optionVariants = JSON.parse(optionVariantsElement.textContent);
          this.hasCombinedListings = Array.isArray(this.optionVariants) && this.optionVariants.length > 0;
        }
        
        if (optionUrlsElement) {
          this.optionUrls = JSON.parse(optionUrlsElement.textContent);
        }
        
      } catch (error) {
      }
    }

    onVariantChange(e) {
      // Only proceed if the change event is from an actual variant radio input
      if (!this.#isVariantRadioChange(e)) {
        return;
      }
      
      this.updateVariantSelectedState(true);
      
      // IMPORTANT: Update options based on the event target, not DOM state
      // The change event fires before DOM updates, so we need to use the clicked radio's value
      this.updateOptionsFromEvent(e);
      
      this.updateOutputs();
      this.updateVariantsBasedOn(e.target.closest("fieldset"));
      this.updateMasterId();
      this.updateStickyOutput();
      this.handleAvailabilityStates();
      this.removeErrorMessage();
      
      // Determine which fieldset was changed
      const changedFieldset = e.target.closest('fieldset');
      const changedFieldsetIndex = changedFieldset ? this.fieldsets.findIndex(fs => fs === changedFieldset) : -1;
      
      this.updateCurrentProductUrl(changedFieldsetIndex);
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateMedia(e);
      this.syncOthers();
    }

    isAllVariantsSelected() {
      return this.fieldsets.every((fieldset) =>
        [...fieldset.elements].some((element) => element.checked)
      );
    }

    updateVariantSelectedState(boolean) {
      this.productParentElement.dataset.variantSelected = boolean;
    }

    updateOutputs() {
      this.outputs.forEach((output) => {
        output.innerHTML = this.options[output.dataset.index];
      });
    }

    updateStickyOutput() {
      if(!this.stickyOutput) return;
      if (!this.currentVariant) {
        return;
      }
      
      try {
        this.stickyOutput.innerHTML = this.currentVariant.title || '';
        if (this.stickyImageOutput && this.currentVariant.featured_image?.src) {
          this.stickyImageOutput.src = this.currentVariant.featured_image.src;
        }
      } catch (error) {
      }
     }

    /**
     * Update the current color URL based on selected color option
     * @private
     */
    /**
     * Update the current product URL based on selected options
     * @param {number} changedFieldsetIndex - Index of the fieldset that was just changed (-1 if unknown)
     */
    updateCurrentProductUrl(changedFieldsetIndex = -1) {
      if (!this.hasCombinedListings || !this.options) {
        this.currentProductUrl = null;
        return;
      }

      try {
        // Prefer data-product-url on the selected option (stable when DOM is re-sorted
        // or when other options disable some values).
        const optionIndicesToCheck = [];
        if (changedFieldsetIndex >= 0 && changedFieldsetIndex < this.options.length) {
          optionIndicesToCheck.push(changedFieldsetIndex);
          for (let i = 0; i < this.options.length; i++) {
            if (i !== changedFieldsetIndex) optionIndicesToCheck.push(i);
          }
        } else {
          for (let i = 0; i < this.options.length; i++) {
            optionIndicesToCheck.push(i);
          }
        }

        for (const optionIndex of optionIndicesToCheck) {
          const selectedValue = this.options[optionIndex];
          if (!selectedValue) continue;

          const fieldset = this.fieldsets[optionIndex];
          if (!fieldset) continue;

          const checkedRadio = [...fieldset.elements].find(
            (el) => el.type === "radio" && el.checked && el.value === selectedValue
          );
          const urlFromData = checkedRadio
            ?.closest("[data-product-url]")
            ?.getAttribute("data-product-url");
          if (urlFromData) {
            this.currentProductUrl = urlFromData;
            return;
          }

          // Fallback: optionUrls index (initial Liquid order)
          if (!this.optionUrls?.[optionIndex]) continue;
          const radios = [...fieldset.elements].filter(
            (el) =>
              el.type === "radio" &&
              el.name &&
              el.name.includes("-") &&
              !el.disabled
          );
          const selectedIndex = radios
            .map((radio) => radio.value)
            .findIndex((value) => value === selectedValue);

          if (
            selectedIndex >= 0 &&
            selectedIndex < this.optionUrls[optionIndex].length
          ) {
            const url = this.optionUrls[optionIndex][selectedIndex];
            if (url) {
              this.currentProductUrl = url;
              return;
            }
          }
        }

        this.currentProductUrl = null;
      } catch (error) {
        this.currentProductUrl = null;
      }
    }

    /**
     * Hide color swatches that are invalid for the current Style/Size selection.
     * Style option pills already use peer-disabled:hidden; swatches did not.
     * @private
     */
    #syncColorSwatchVisibility() {
      this.querySelectorAll('input.swatch[type="radio"]').forEach((radio) => {
        const wrap = radio.closest("span.contents");
        if (!wrap) return;
        const invalid =
          radio.disabled || radio.getAttribute("found") === "false";
        // display:contents wrappers must be toggled explicitly to remove from layout
        wrap.style.display = invalid ? "none" : "";
      });
    }

    /**
     * When revenue color sort is enabled, keep valid colors (for the current
     * Style/Size/etc. selection) ordered by data-revenue-90d, highest first.
     * Invalid combinations sort after valid ones.
     * @private
     */
    #sortRevenueColorSwatches() {
      const containers = this.querySelectorAll("[data-revenue-color-swatches]");
      if (!containers.length) return;

      containers.forEach((container) => {
        const items = [
          ...container.querySelectorAll(":scope > span.contents[data-revenue-90d]"),
        ];
        if (items.length < 2) return;

        const rank = (el) => {
          const radio = el.querySelector('input[type="radio"]');
          const isValid =
            radio &&
            !radio.disabled &&
            radio.getAttribute("found") !== "false";
          const revenue = Number(el.dataset.revenue90d) || 0;
          return { isValid: isValid ? 1 : 0, revenue };
        };

        items.sort((a, b) => {
          const ra = rank(a);
          const rb = rank(b);
          if (ra.isValid !== rb.isValid) return rb.isValid - ra.isValid;
          return rb.revenue - ra.revenue;
        });

        items.forEach((el) => container.appendChild(el));
      });
    }

    updateOptions() {
      this.options = this.fieldsets.map((fieldset) => {
        if (![...fieldset.elements].find((radio) => radio.checked && radio.type === 'radio')) return "";
        return [...fieldset.elements].find((radio) => radio.checked && radio.type === 'radio').value;
      });
    }

    /**
     * Update options based on change event target
     * This is more reliable than reading from DOM since change events fire before DOM updates
     * @param {Event} e - Change event
     */
    updateOptionsFromEvent(e) {
      const eventRadio = e.target;
      if (!eventRadio || eventRadio.type !== 'radio') {
        // Fallback to DOM reading if event target is not a radio
        this.updateOptions();
        return;
      }

      const changedFieldset = eventRadio.closest('fieldset');
      if (!changedFieldset) {
        this.updateOptions();
        return;
      }

      // Find the index of the fieldset that was changed
      const fieldsetIndex = this.fieldsets.findIndex(fs => fs === changedFieldset);
      if (fieldsetIndex === -1) {
        this.updateOptions();
        return;
      }

      // Initialize options array if needed
      if (!this.options || this.options.length !== this.fieldsets.length) {
        this.options = new Array(this.fieldsets.length).fill("");
      }

      // Determine the newly selected value
      // IMPORTANT: Always find the checked radio in the fieldset
      // Even though the change event fires, we should read the actual checked state
      // to be safe, as there can be timing issues
      let newValue = "";
      
      // Find the checked radio in the fieldset
      // Filter for radio buttons only (exclude checkbox for "instock-only")
      const allRadios = [...changedFieldset.elements].filter(el => 
        el.type === 'radio' && el.name && el.name.includes('-')
      );
      const checkedRadio = allRadios.find(radio => radio.checked);
      
      if (checkedRadio) {
        newValue = checkedRadio.value;
      } else if (eventRadio.checked) {
        // Fallback: use event target if no checked radio found but event target is checked
        newValue = eventRadio.value;
      }

      // Update the option for this fieldset
      this.options[fieldsetIndex] = newValue;

      // For all other fieldsets, read from DOM (they should be stable)
      this.fieldsets.forEach((fieldset, index) => {
        if (index !== fieldsetIndex) {
          const checkedRadio = [...fieldset.elements].find((radio) => radio.checked && radio.type === 'radio');
          if (checkedRadio) {
            this.options[index] = checkedRadio.value;
          } else {
            this.options[index] = "";
          }
        }
      });
    }

    syncOthers() {
      this.variantRadiosArray =
        this.productParentElement.querySelectorAll(`variant-radios`);

      this.variantRadiosArray.forEach((variantRadios) => {
        variantRadios
          .querySelectorAll("fieldset")
          .forEach((fieldset, index) => {
            [...fieldset.elements]
              .find((radio) => {
                return radio.value === this.options[index];
              })
              .click();
          });
      });
    }

    updateMasterId() {
      try {
        
        const variantData = this.getVariantData();
        
        if (!variantData || !Array.isArray(variantData)) {
          this.#handleVariantError('Invalid variant data');
          return;
        }

        if (!this.options || this.options.length === 0) {
          this.currentVariant = variantData.find(v => v.available) || variantData[0] || null;
        } else {
          
          // Check if we have incomplete selections
          const expectedOptionsCount = this.fieldsets.length;
          const actualOptionsCount = this.options.filter(opt => {
            if (opt === null || opt === undefined) return false;
            if (typeof opt === 'string') {
              return opt.trim() !== '';
            }
            return true;
          }).length;
          
          // Normalize options for better matching
          const normalizedOptions = this.options.map(opt => {
            if (opt === null || opt === undefined || opt === '') {
              return null;
            }
            return typeof opt === 'string' ? opt.trim() : opt;
          });
          
          // If we don't have all options selected, don't try to match - use first available as fallback
          if (actualOptionsCount < expectedOptionsCount) {
            this.currentVariant = variantData.find(v => v.available) || variantData[0] || null;
          } else {
            // All options are selected - find exact match using the helper method
            this.currentVariant = this.#checkVariantAvailability(normalizedOptions);
          }
        }
        
        if (!this.currentVariant) {
          // Try fallback strategies
          
          // Strategy 1: Use first available variant
          this.currentVariant = variantData.find(v => v.available) || variantData[0] || null;
          
          if (!this.currentVariant) {
            this.#handleVariantError('No matching variant found and no fallback available');
            return;
          }
        }
        
        
        // Safely update quantity selector
        if (this.quantitySelector) {
          this.quantitySelector.dataset.id = this.currentVariant.id;
        }
        
      } catch (error) {
        this.#handleVariantError('Error updating variant selection', error);
      }
    }

    /**
     * Check if a combination of options exists in variant data
     * @param {Array<string|null>} testOptions - Array of option values to test (null for unselected)
     * @returns {Object|null} Matching variant or null
     * @private
     */
    #checkVariantAvailability(testOptions) {
      if (!testOptions || testOptions.length === 0) {
        return null;
      }

      const variantData = this.getVariantData();
      if (!variantData || !Array.isArray(variantData)) {
        return null;
      }

      // Find variant where all non-null test options match
      return variantData.find((variant) => {
        // Skip invalid variants - must be an object with options array
        if (!variant || typeof variant !== 'object') {
          return false;
        }
        
        if (!variant.options || !Array.isArray(variant.options) || variant.options.length === 0) {
          return false;
        }

        // Only compare the first N options where N is the number of fieldsets
        // Variants may have additional options like "Default Title" that we ignore
        const fieldsetsCount = this.fieldsets.length;
        const maxCompareLength = Math.min(testOptions.length, fieldsetsCount);

        // Variant must have at least as many options as we need to compare
        if (variant.options.length < maxCompareLength) {
          return false;
        }

        // Check if all non-null test options match variant options (only compare first N)
        const matches = testOptions.slice(0, maxCompareLength).every((testOption, index) => {
          // If test option is null (not selected), skip this check
          if (testOption === null || testOption === undefined || testOption === '') {
            return true;
          }

          // Validate variant.options still exists (defensive check)
          if (!variant.options || index >= variant.options.length) {
            return false;
          }

          // Normalize both values for comparison
          const normalizedTest = typeof testOption === 'string' ? testOption.trim() : testOption;
          const variantOption = variant.options[index];
          
          // Handle null/undefined variant option
          if (variantOption === null || variantOption === undefined || variantOption === '') {
            return false;
          }
          
          const normalizedVariant = typeof variantOption === 'string' ? variantOption.trim() : variantOption;

          return normalizedTest === normalizedVariant;
        });
        
        return matches;
      }) || null;
    }

    updateVariantsBasedOn(baseFieldset = this.fieldsets[0]) {
      if (baseFieldset == null) {
        baseFieldset = this.fieldsets[0];
      }

      // Handle single option variants
      if (this.fieldsets.length === 1) {
        for (const radio of [...baseFieldset.elements]) {
          // skip if radio is not a radio
          if (radio.type !== 'radio') continue;
          const variant = this.getVariantData().find(
            (variant) => variant && 
                        variant.options && 
                        Array.isArray(variant.options) && 
                        variant.options.length > 0 &&
                        variant.options[0] === radio.value
          );
          const hasVariant = variant !== undefined;
          radio.setAttribute("found", hasVariant ? "true" : "false");
          radio.setAttribute("available", hasVariant && variant?.available ? "true" : "false");
          radio.disabled = !hasVariant;
        }
        this.#syncColorSwatchVisibility();
        this.#sortRevenueColorSwatches();
        this.updateInstockOnlyFilter();
        return;
      }

      // Get all currently selected options across all fieldsets
      const selectedOptions = this.fieldsets.map((fieldset) => {
        const checked = [...fieldset.elements].find((radio) => radio.checked && radio.type === 'radio');
        return checked ? checked.value : null;
      });

      let shouldHandleUnavailableSelects = false;

      // For each fieldset, check all options against currently selected options in other fieldsets
      this.fieldsets.forEach((fieldset, fieldsetIndex) => {
        // Check if other fieldsets have selections (excluding current fieldset)
        const otherFieldsetsHaveSelections = selectedOptions.some((opt, index) => 
          index !== fieldsetIndex && opt !== null
        );

        [...fieldset.elements]
          .filter(el => el.type === 'radio')
          .forEach((radio) => {
          // If no other fieldsets have selections, enable all options by default
          // We'll disable them once the user makes a selection
          if (!otherFieldsetsHaveSelections) {
            radio.setAttribute("found", "true");
            radio.setAttribute("available", "true");
            radio.disabled = false;
            return;
          }

          // Build test combination: use this radio's value for this fieldset,
          // and currently selected values for all other fieldsets
          const testOptions = [...selectedOptions];
          // Normalize the radio value (trim whitespace)
          testOptions[fieldsetIndex] = typeof radio.value === 'string' ? radio.value.trim() : radio.value;

          // Check if we have enough selections to make a determination
          // Only disable if we're certain the combination doesn't exist
          const nonNullOptions = testOptions.filter(opt => opt !== null && opt !== undefined && opt !== '');

          // If we have all options filled, check for exact match
          // If we have partial options, check if ANY variant could match
          let hasVariant = false;
          let isAvailable = false;

          if (nonNullOptions.length === testOptions.length) {
            // All options selected - check for exact match
            const matchingVariant = this.#checkVariantAvailability(testOptions);
            hasVariant = matchingVariant !== null && matchingVariant !== undefined;
            isAvailable = hasVariant && matchingVariant.available === true;
          } else {
            // Partial selection - check if this option value exists at this position
            // AND if selected options in other positions match
            const variantData = this.getVariantData();
            const matchingVariant = variantData.find((variant) => {
              if (!variant || !variant.options || !Array.isArray(variant.options)) {
                return false;
              }
              // Only compare the first N options where N is the number of fieldsets
              const fieldsetsCount = this.fieldsets.length;
              const maxCompareLength = Math.min(testOptions.length, fieldsetsCount);
              
              if (variant.options.length < maxCompareLength) {
                return false;
              }
              
              // Check that all non-null test options match, and this option matches at this position
              const allMatch = testOptions.slice(0, maxCompareLength).every((testOpt, idx) => {
                if (testOpt === null || testOpt === undefined || testOpt === '') {
                  return true; // Skip null checks
                }
                const normalizedTest = typeof testOpt === 'string' ? testOpt.trim() : testOpt;
                const variantOpt = variant.options[idx];
                if (variantOpt === null || variantOpt === undefined) return false;
                const normalizedVariant = typeof variantOpt === 'string' ? variantOpt.trim() : variantOpt;
                const matches = normalizedTest === normalizedVariant;
                return matches;
              });
              return allMatch;
            });
            hasVariant = matchingVariant !== null && matchingVariant !== undefined;
            isAvailable = hasVariant && matchingVariant.available === true;
          }

          // Update attributes
          radio.setAttribute("found", hasVariant ? "true" : "false");
          radio.setAttribute("available", isAvailable ? "true" : "false");
          radio.disabled = !hasVariant;

          // If a checked option becomes unavailable, mark for handling
          if (radio.checked && !hasVariant) {
            shouldHandleUnavailableSelects = true;
          }
        });
      });

      // Hide invalid colors, then re-rank remaining by revenue (if enabled)
      this.#syncColorSwatchVisibility();
      this.#sortRevenueColorSwatches();

      if (shouldHandleUnavailableSelects) {
        this.handleUnavailableSelects();
        // Fallback selection may change found/disabled state for checked radios
        this.#syncColorSwatchVisibility();
      }
      
      // Update instock-only filter visibility after attributes are updated
      this.updateInstockOnlyFilter();
    }
    
    /**
     * Update visibility of variant options based on instock-only checkbox state.
     * When checked: hide options with data-out-of-stock (inventory_quantity < 1).
     * When unchecked: show all. Public method callable from inline handlers.
     * Below theme `lg`, the control is hidden and this is a no-op (all options visible).
     */
    updateInstockOnlyFilter() {
      const options = this.querySelectorAll(
        ".instock-only-fieldset span.contents"
      );

      const isInvalidOption = (option) => {
        const radio = option.querySelector('input[type="radio"]');
        return Boolean(
          radio &&
            (radio.disabled || radio.getAttribute("found") === "false")
        );
      };

      if (!this.#isInstockOnlyDesktopViewport()) {
        options.forEach((option) => {
          // Keep invalid color/style combos hidden even when instock filter is N/A
          option.style.display = isInvalidOption(option) ? "none" : "";
        });
        return;
      }

      const instockCheckbox = this.querySelector("#instock-only");
      const isChecked = Boolean(instockCheckbox?.checked);

      options.forEach((option) => {
        if (isInvalidOption(option)) {
          option.style.display = "none";
          return;
        }
        const outOfStock = option.querySelector("[data-out-of-stock]");
        if (isChecked && outOfStock) {
          option.style.display = "none";
        } else {
          option.style.display = "";
        }
      });
    }

    updateMedia(e) {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      this.productParentElement
        .querySelector(
          `slider-thumbnails [data-media-id="${this.currentVariant.featured_media.id}"]`
        )
        ?.click();
    }

    updateURL() {
      if (
        this.quickAtcMode ||
        !this.currentVariant ||
        this.dataset.updateUrl === "false" ||
        !window.location.pathname.includes("/products/") ||
        !this.dataset.section.includes("product-main")
      )
        return;
        
      try {
        // For combined listings, update URL to the product URL based on selected options
        if (this.hasCombinedListings && this.currentProductUrl) {
          
          // Update the URL without reloading the page
          window.history.replaceState(
            {},
            "",
            this.currentProductUrl
          );
          return;
        }

        // Regular variant URL update
        if (this.urlSearchParams.length > 0) {
          if (this.urlSearchParams.includes("variant=")) {
            let regex = /(variant=[0-9])\w+/g;
            const urlVariantParams = this.urlSearchParams.replace(
              regex,
              `variant=${this.currentVariant.id}`
            );
            window.history.replaceState(
              {},
              "",
              `${this.dataset.url}${urlVariantParams}`
            );
          } else {
            window.history.replaceState(
              {},
              "",
              `${this.dataset.url}${this.urlSearchParams}&variant=${this.currentVariant.id}`
            );
          }
        } else {
          window.history.replaceState(
            {},
            "",
            `${this.dataset.url}?variant=${this.currentVariant.id}`
          );
        }
      } catch (error) {
      }
    }

    updateShareUrl() {
      if (!this.currentVariant) {
        return;
      }
      
      try {
        const shareButton = document.getElementById(
          `Share-${this.dataset.section}-${this.dataset.product}`
        );
        if (!shareButton) return;
        shareButton.updateUrl(
          `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
        );
      } catch (error) {
      }
    }

    updateVariantInput() {
      if (!this.currentVariant) {
        return;
      }
      
      try {
        // Re-query on every update: `product-form` often appears *after* `variant-radios`
        // in the DOM (e.g. PDP), so constructor-time `querySelectorAll("product-form")`
        // can be permanently empty if cached there.
        const variantId = String(this.currentVariant.id);
        const productForms =
          this.productParentElement.querySelectorAll("product-form");
        productForms.forEach((productForm) => {
          productForm.querySelectorAll('input[name="id"]').forEach((input) => {
            input.value = variantId;
            input.dispatchEvent(new Event("change", { bubbles: true }));
          });
        });

        // Also update forms in product-card-atc components (for sticky ATC)
        const productCardAtcs = this.productParentElement.querySelectorAll('product-card-atc');
        productCardAtcs.forEach((atcComponent) => {
          const form = atcComponent.querySelector('form[data-type="add-to-cart-form"]');
          if (form) {
            const input = form.querySelector('input[name="id"]');
            if (input) {
              input.value = this.currentVariant.id;
              input.dispatchEvent(new Event("change", { bubbles: true }));
            }
          }
        });
      } catch (error) {
      }
    }

    removeErrorMessage() {
      const section = this.closest("section");
      if (!section) return;

      const productForm = section.querySelector("product-form");
      if (productForm) productForm.handleErrorMessage();
    }

    renderProductInfo() {
      if (!this.currentVariant) {
        return;
      }

      try {
        const productParentElement = this.productParentElement;
        this.#rebindProductContext();
        const productId =
          productParentElement?.dataset.product || this.dataset.product;
        const currentSelectedOptions = [...(this.options || [])];
        const variantId = this.currentVariant.id;
        const primarySectionId = this.dataset.section;
        const productUrl =
          this.hasCombinedListings && this.currentProductUrl
            ? this.currentProductUrl
            : this.dataset.url;
        const pageWide = this.dataset.quickAtcMode !== 'true';

        const variantDynamicElements = collectVariantDynamicElements({
          productRoot: productParentElement,
          productId,
          pageWide,
        });

        if (variantDynamicElements.length === 0) {
          return;
        }

        this.#variantDynamicAbortController?.abort();
        this.#variantDynamicAbortController = new AbortController();
        const requestId = ++this.#variantDynamicRequestId;
        const { signal } = this.#variantDynamicAbortController;

        updateVariantDynamicSections({
          buildFetchUrl: (sectionId) =>
            `${productUrl}?variant=${variantId}&section_id=${sectionId}`,
          elements: variantDynamicElements,
          productRoot: productParentElement,
          primarySectionId,
          preservedSelectedOptions: currentSelectedOptions,
          signal,
          variantId,
          dispatchEvent: ({ phase }) => {
            productParentElement.dispatchEvent(
              new CustomEvent('variant:content-updated', {
                detail: { phase, variantId },
                bubbles: true,
              }),
            );
          },
        })
          .then(() => {
            if (requestId !== this.#variantDynamicRequestId) return;

            const featuredMediaId = this.currentVariant?.featured_media?.id;
            if (!featuredMediaId) return;

            requestAnimationFrame(() => {
              const thumb = productParentElement.querySelector(
                `[data-product-gallery] [data-product-gallery-thumb][data-media-id="${featuredMediaId}"]`,
              );
              thumb?.dispatchEvent(new MouseEvent('mouseenter', { bubbles: true }));
            });
          })
          .catch((error) => {
            if (error.name === 'AbortError') return;
          });
      } catch (error) {
      }
    }

    handleUnavailableSelects() {
      let selectedButUnavailables = this.fieldsets.reduce(
        (acc = [], fieldset) => {
          let found = [...fieldset.elements]
            .filter(el => el.type === 'radio')
            .find(
            (input) => input.checked && input.getAttribute("found") === "false"
          );
          if (found) acc.push(found);
          return acc;
        },
        []
      );

      if (!selectedButUnavailables) return;

      selectedButUnavailables.forEach((input) => {
        const availableSibling = [...input.closest("fieldset").elements]
          .filter(el => el.type === 'radio')
          .find(
          (input) => input.getAttribute("found") !== "false"
        );
        if (!availableSibling) return;
        availableSibling.checked = true;
        this.updateOptions();
      });
    }

    handleAvailabilityStates() {
      if (!this.productButtons) return;

      let available = !this.fieldsets.some((fieldset) =>
        [...fieldset.elements]
          .filter(el => el.type === 'radio')
          .some(
          (input) =>
            input.checked && input.getAttribute("available") === "false"
        )
      );
      this.productButtons.forEach((button) =>
        button.setAttribute("available", available)
      );
      this.qtyInput?.setAttribute("available", available);
    }

    getVariantData() {
      // Always use regular variant data for availability checks
      // optionVariants only contains one variant per option value (selected_or_first_available_variant)
      // which is insufficient for checking all possible combinations
      return this.#getRegularVariantData();
    }

    #getRegularVariantData() {
      // Read variant data from DOM - should now include all variants from all color products
      const variantJsonElement = this.querySelector(".variant-json");
      if (!variantJsonElement) {
        return [];
      }
      
      const variantData = JSON.parse(variantJsonElement.textContent);
      
      return variantData || [];
    }

    fetchVariantForm(e) {
      e.preventDefault();
      if (
        e.currentTarget.href.includes(this.productParentElement.dataset.handle)
      ) {
        return;
      }

      fetch(`${e.currentTarget.href}?section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const destination = document.querySelector(
            `[data-section="${this.dataset.section}"]`
          );
          const source = html.querySelector(".shopify-section");

          if (source && destination) {
            source.querySelector;
            destination.innerHTML = source.innerHTML;
            return true;
          } else {
            return false;
          }
        });
    }

    /**
     * Handle variant-related errors gracefully
     * @param {string} message - Error message
     * @param {Error} [error] - Original error object
     * @private
     */
    #handleVariantError(message, error = null) {
      
      // Dispatch error event for parent components
      this.dispatchEvent(new CustomEvent('variant:error', {
        detail: { 
          message, 
          error: error?.message || null,
          options: this.options,
          currentVariant: this.currentVariant
        },
        bubbles: true
      }));
      
      // Set currentVariant to null to prevent further errors
      this.currentVariant = null;
      
      // Update availability states to reflect error
      if (this.productButtons) {
        this.productButtons.forEach((button) =>
          button.setAttribute("available", "false")
        );
      }
      if (this.qtyInput) {
        this.qtyInput.setAttribute("available", "false");
      }
    }
  }

  customElements.define("variant-radios", VariantRadios);
}

(function setupAffirmVariantAmountSync() {
  if (window.__affirmVariantAmountSyncSetup) return;
  window.__affirmVariantAmountSyncSetup = true;

  function getAmountFromVariantInput(variantInput, productForm) {
    const affirmWrapper = productForm.querySelector('[data-affirm-wrapper]');
    const pricesScript = affirmWrapper
      ? affirmWrapper.querySelector('script[data-affirm-variant-prices]')
      : null;

    if (pricesScript) {
      try {
        const variantPrices = JSON.parse(pricesScript.textContent || '{}');
        const mappedAmount = variantPrices[String(variantInput.value)];
        if (mappedAmount != null) return mappedAmount;
      } catch (_) {}
    }

    const productRoot =
      productForm.closest('[data-product]') ||
      productForm.closest('[data-section][data-product]');
    const productId = productRoot ? productRoot.getAttribute('data-product') : null;
    let variantRadios = productRoot ? productRoot.querySelector('variant-radios') : null;

    if (!variantRadios && productId) {
      variantRadios = document.querySelector(
        `variant-radios[data-product="${productId}"]`
      );
    }

    if (
      variantRadios &&
      variantRadios.currentVariant &&
      variantRadios.currentVariant.price != null
    ) {
      return variantRadios.currentVariant.price;
    }

    return null;
  }

  function lockWrapperHeight(wrapper) {
    if (!wrapper) return;
    const currentHeight = wrapper.offsetHeight;
    const previousMax = Number(wrapper.getAttribute('data-affirm-max-height') || 0);
    const maxHeight = Math.max(previousMax, currentHeight);
    wrapper.setAttribute('data-affirm-max-height', String(maxHeight));
    wrapper.style.minHeight = `${maxHeight}px`;
  }

  function refreshAffirm(affirmMessaging, wrapper) {
    if (!window.affirm || !window.affirm.ui) return;

    if (affirmMessaging.__affirmRefreshTimer) {
      clearTimeout(affirmMessaging.__affirmRefreshTimer);
    }

    const runRefresh = function () {
      if (typeof window.affirm.ui.refresh === 'function') {
        window.affirm.ui.refresh();
      }
      requestAnimationFrame(function () {
        lockWrapperHeight(wrapper);
      });
      setTimeout(function () {
        lockWrapperHeight(wrapper);
      }, 120);
    };

    affirmMessaging.__affirmRefreshTimer = setTimeout(function () {
      if (typeof window.affirm.ui.ready === 'function') {
        window.affirm.ui.ready(runRefresh);
        return;
      }
      runRefresh();
    }, 90);
  }

  function updateAffirmAmount(variantInput) {
    if (!variantInput) return;

    const form = variantInput.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;

    const productForm = form.closest('product-form');
    if (!productForm) return;

    const affirmWrapper = productForm.querySelector('[data-affirm-wrapper]');
    const affirmMessaging = affirmWrapper
      ? affirmWrapper.querySelector('affirm-messaging')
      : null;
    if (!affirmMessaging) return;

    const amount = getAmountFromVariantInput(variantInput, productForm);
    if (amount == null) return;

    const currentAmount = affirmMessaging.getAttribute('data-amount');
    if (String(currentAmount) === String(amount)) {
      lockWrapperHeight(affirmWrapper);
      return;
    }

    pulseAffirmMessage(affirmMessaging);

    affirmMessaging.setAttribute('data-amount', String(amount));
    const affirmSpan = affirmMessaging.querySelector('.affirm-as-low-as');
    if (affirmSpan) {
      affirmSpan.setAttribute('data-amount', String(amount));
    }

    lockWrapperHeight(affirmWrapper);
    refreshAffirm(affirmMessaging, affirmWrapper);
  }

  function pulseAffirmMessage(affirmMessaging) {
    if (!affirmMessaging) return;
    if (typeof affirmMessaging.animate !== 'function') return;

    try {
      if (affirmMessaging.__affirmUpdatePulse) {
        affirmMessaging.__affirmUpdatePulse.cancel();
      }

      const pulse = affirmMessaging.animate(
        [
          { opacity: 1 },
          { opacity: 0.35, offset: 0.45 },
          { opacity: 1 },
        ],
        {
          duration: 260,
          easing: 'ease-in-out',
        }
      );

      affirmMessaging.__affirmUpdatePulse = pulse;
      pulse.addEventListener(
        'finish',
        function () {
          affirmMessaging.__affirmUpdatePulse = null;
        },
        { once: true }
      );
      pulse.addEventListener(
        'cancel',
        function () {
          affirmMessaging.__affirmUpdatePulse = null;
        },
        { once: true }
      );
    } catch (_) {}
  }

  document.addEventListener('change', function (event) {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (target.name !== 'id') return;
    updateAffirmAmount(target);
  });

  document.addEventListener('DOMContentLoaded', function () {
    document
      .querySelectorAll('product-form form[data-type="add-to-cart-form"] input[name="id"]')
      .forEach(function (input) {
        updateAffirmAmount(input);
      });
  });

  window.addEventListener('variant:content-updated', function (event) {
    const root = event.target;
    if (!(root instanceof Element)) return;
    root.querySelectorAll('product-form input[name="id"]').forEach(function (input) {
      updateAffirmAmount(input);
    });
  });
})();

/**
 * Affirm Messaging Web Component
 * Lazy-loads Affirm script on first connect (product page or quick-add modal).
 * Re-initializes Affirm when shown in dynamic contexts (modals, variant changes).
 */
if (!customElements.get('affirm-messaging')) {
  class AffirmMessaging extends HTMLElement {
    /** @type {AbortController} */
    abortController = new AbortController();

    /** Affirm config + loader IIFE – injected on demand, not in head */
    static #AFFIRM_LOADER = `_affirm_config={public_api_key:"QH8K3PS5TUU25D53",script:"https://cdn1.affirm.com/js/v2/affirm.js"};(function(l,g,m,e,a,f,b){var d,c=l[m]||{},h=document.createElement(f),n=document.getElementsByTagName(f)[0],k=function(a,b,c){return function(){a[b]._.push([c,arguments])}};c[e]=k(c,e,"set");d=c[e];c[a]={};c[a]._=[];d._=[];c[a][b]=k(c,a,b);a=0;for(b="set add save post open empty reset on off trigger ready setProduct".split(" ");a<b.length;a++)d[b[a]]=k(c,e,b[a]);a=0;for(b=["get","token","url","items"];a<b.length;a++)d[b[a]]=function(){};h.async=!0;h.src=g[f];n.parentNode.insertBefore(h,n);delete g[f];d(g);l[m]=c})(window,_affirm_config,"affirm","checkout","ui","script","ready");`;

    connectedCallback() {
      this.#renderAffirmSpan();
      this.#loadOrReinitAffirm();
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    /** Inject Affirm loader script; no-op if already injected and not re-initing */
    #loadOrReinitAffirm() {
      const affirmLoaded = document.querySelector('script[src*="affirm.com/js"]');
      const loaderExists = document.querySelector('script[data-affirm-loader]');
      const isReinit = Boolean(affirmLoaded);

      if (!isReinit && loaderExists) return;

      if (isReinit) {
        if (window.affirm) {
          try { delete window.affirm; } catch (_) {}
        }
        document.querySelectorAll('script[src*="affirm.com/js"]').forEach((s) => s.remove());
        document.querySelectorAll('script[data-affirm-loader]').forEach((s) => s.remove());
      }

      const loader = document.createElement('script');
      loader.setAttribute('data-affirm-loader', '');
      loader.textContent = AffirmMessaging.#AFFIRM_LOADER;
      document.body.appendChild(loader);
    }

    #renderAffirmSpan() {
      this.innerHTML = '';
      const span = document.createElement('span');
      span.className = 'affirm-as-low-as';
      span.setAttribute('data-page-type', this.getAttribute('data-page-type') || 'product');
      span.setAttribute('data-amount', this.getAttribute('data-amount') || '');
      this.appendChild(span);
    }
  }

  customElements.define('affirm-messaging', AffirmMessaging);
}

function findAndReplaceStringInQuotes(originalString, replacementString) {
  // Create a regular expression pattern to match the string inside double quotes
  var regex = /"(.*?)"/g;

  // Use the `replace` method to replace the content inside the double quotes
  var modifiedString = originalString.replace(
    regex,
    '"' + replacementString + '"'
  );

  return modifiedString;
}
